import React from 'react';
import { bool, func, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { intlShape, injectIntl } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import { Form, Button, FieldTextInput, FieldSelect } from '../../../../components';
import css from './EditListingServicesForm.module.css';

export const EditListingServiceFormComponent = props => {
  const { onAddNewService, avalilableDurations, formHasChanged, ...rest } = props;

  return (
    <FinalForm
      {...rest}
      render={formRenderProps => {
        const {
          className,
          disabled,
          handleSubmit,
          invalid,
          pristine,
          saveActionMsg,
          updated,
          updateError,
          updateInProgress,
          values,
          form,
          currency,
        } = formRenderProps;

        const errorMessage = updateError ? <p className={css.error}>Try again</p> : null;

        const classes = classNames(css.root, className);
        const submitReady = updated && pristine;
        const submitInProgress = updateInProgress;

        const allFieldsFilled = Object.values(values).every(value => value != null);

        const addDisabled = !allFieldsFilled || invalid || disabled || submitInProgress;

        return (
          <Form className={classes} onSubmit={handleSubmit}>
            {errorMessage}

            <FieldTextInput
              className={css.input}
              name="serviceName"
              id="serviceName"
              label="Service name"
              type="text"
              placeholder="Wash & Retwist"
            />

            <FieldTextInput
              className={css.input}
              name="servicePrice"
              id="servicePrice"
              type="number"
              step="1"
              placeholder="70"
              parse={value => {
                const parsed = Number.parseInt(value, 10);
                return Number.isNaN(parsed) ? null : parsed;
              }}
              label={`Total price (${currency})`}
            />

            <FieldSelect
              className={css.input}
              name="serviceDuration"
              id="serviceDuration"
              label="Duration"
            >
              <option disabled value="">
                Select service duration
              </option>
              {avalilableDurations.map(option => {
                const label = `${option} Hour${option > 1 ? 's' : ''}`;
                return (
                  <option key={option} value={option}>
                    {label}
                  </option>
                );
              })}
            </FieldSelect>

            <FieldTextInput
              className={css.input}
              id="serviceDescription"
              name="serviceDescription"
              type="textarea"
              label="Description"
              placeholder="Describe this service"
            />
            <Button
              className={css.addServiceButton}
              type="button"
              inProgress={submitInProgress}
              disabled={addDisabled}
              onClick={() => {
                onAddNewService(values);
                form.reset();
              }}
            >
              <span style={{ fontSize: 21 }}>+</span> Add
            </Button>

            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={!formHasChanged}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
          </Form>
        );
      }}
    />
  );
};

EditListingServiceFormComponent.propTypes = {
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
};

export default compose(injectIntl)(EditListingServiceFormComponent);
